import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.VoorlopigeDekkingen, {
  isVisible: (settings: EnvironmentSettings) => settings.heeftVoorlopigeDekkingPermissie,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.VoorlopigeDekkingen,
    title: 'Voorlopige dekkingen',
    url: '/app/offerte/voorlopige-dekkingen/',
    iconclass: 'fas fa-car',
    target: '_top',
  }),
});
